import { camelToTitleCase } from "@bloglovin/vue-framework";

const MAX_HOPS = 2;

function persistedReferences(entityDefinition) {
  return Object.entries(entityDefinition?.fields ?? {})
      .filter(([, fieldDef]) => fieldDef?.type === "oneEntity" && !fieldDef.stateOnly && fieldDef.entity);
}

export function readPositionFieldCandidates(ownerEntityType, rowEntityType, findEntityDefinition) {
  if (!ownerEntityType || !rowEntityType) {
    return [];
  }
  const candidates = [];
  const walk = (entityType, path, labels, depth) => {
    persistedReferences(findEntityDefinition(entityType)).forEach(([fieldName, fieldDef]) => {
      const nextPath = [...path, fieldName];
      const nextLabels = [...labels, camelToTitleCase(fieldName)];
      if (fieldDef.entity === rowEntityType) {
        candidates.push({ id: nextPath.join("."), name: nextLabels.join(" › ") });
        return;
      }
      if (depth + 1 < MAX_HOPS && fieldDef.entity !== ownerEntityType) {
        walk(fieldDef.entity, nextPath, nextLabels, depth + 1);
      }
    });
  };
  walk(ownerEntityType, [], [], 0);
  return candidates.sort((a, b) => a.id.localeCompare(b.id));
}

export function readPositionActionCandidates(ownerEntityType, findEntityDefinition) {
  const actions = Object.keys(findEntityDefinition(ownerEntityType)?.actions ?? {}).sort();
  return [{ id: "", name: "Don't mark it read" }, ...actions.map(action => ({ id: action, name: camelToTitleCase(action) }))];
}

export function insertReadPositionSection(rows, anchorPkString, section, pkStringOf) {
  if (!anchorPkString) {
    return rows;
  }
  const anchorIndex = rows.findIndex(item => item.kind === "row" && pkStringOf(item.entity?.entityPk) === anchorPkString);
  if (anchorIndex === -1) {
    return rows;
  }
  return [...rows.slice(0, anchorIndex), section, ...rows.slice(anchorIndex)];
}
